import { RefreshCw } from 'lucide-react'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Button } from '@/components/ui/Button'
import { cn } from '@/lib/cn'
import { useT } from '@/i18n'
import { ListStore, useStores } from '@/stores'
import { clearQueryCache } from '@/stores/queryCache'

/**
 * «Обновить» in the top bar (client, ALFI TEST #2): fetches again every
 * reference list behind the dropdowns and every list on screen, so records
 * added elsewhere show without reloading the page. Typed form values stay.
 */
export const GlobalRefresh = observer(function GlobalRefresh() {
  const t = useT()
  const { lookups } = useStores()
  const [busy, setBusy] = useState(false)

  const refresh = () => {
    if (busy) return
    setBusy(true)
    clearQueryCache()
    ListStore.reloadLive()
    void lookups.refreshAll().finally(() => setBusy(false))
  }

  return (
    <Button variant="ghost" size="icon" onClick={refresh} aria-label={t('layout.topbar.refresh')} title={t('layout.topbar.refresh')} aria-busy={busy}>
      <RefreshCw className={cn('size-4', busy && 'animate-spin')} />
    </Button>
  )
})
